import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, PageSection } from "@patternfly/react-core";
import { NavLink } from "react-router-dom";
export var NotFound = function () { return (_jsxs(PageSection, { children: [_jsx(Alert, { variant: "danger", title: "404! This view hasn't been created yet." }), _jsx("br", {}), _jsx(NavLink, { to: "/", className: "pf-c-nav__link", children: "Take me home" })] })); };
